import React, { useCallback, useEffect, useRef } from "react";
import createPlotlyComponent from "react-plotly.js/factory";
import Plotly from "plotly.js-basic-dist";

const BasePlot = createPlotlyComponent(Plotly);

const defaultConfig = {
  responsive: true,
  displaylogo: false,
  displayModeBar: false,
};

/**
 * Thin Plotly wrapper that purges the figure on unmount so WebGL/canvas
 * from prior graphs does not accumulate when users switch chart types.
 */
const Plot = React.forwardRef((props, ref) => {
  const { config, ...rest } = props;
  const localRef = useRef(null);

  const setRefs = useCallback(
    (node) => {
      localRef.current = node;
      if (typeof ref === "function") {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    },
    [ref]
  );

  useEffect(() => {
    return () => {
      try {
        const el = localRef.current?.el;
        if (el) {
          Plotly.purge(el);
        }
      } catch {
        /* ignore teardown errors */
      }
    };
  }, []);

  return (
    <BasePlot {...rest} config={{ ...defaultConfig, ...config }} ref={setRefs} />
  );
});

Plot.displayName = "Plot";

export default Plot;
